// export const ENV = "staging";

export const getBaseURL = (platform = "aws", env = "staging") => {
    let base_url = "";
    console.log("getBaseURL", env, platform);
    if (env == "local" || env == "staging") {
      if (platform == "aws") {
        base_url = "https://d3ckjemso196la.cloudfront.net/";
      }
      if (platform == "google") {
        base_url = "https://storage.googleapis.com/all3d-dev/";
      }
    }
  
    if (env == "production") {
      if (platform == "aws") {
        let company_id = localStorage.getItem("company_id");
        if (company_id != undefined && BASE_URLS[company_id] != undefined) {
          base_url = BASE_URLS[company_id];
        } else {
          base_url = "https://d48f7equ64qjl.cloudfront.net/";
        }
      }
      if (platform == "google") {
        base_url = "https://storage.googleapis.com/all3d/";
      }
    }
  
    return base_url;
  };
  

export const getUSDZBaseURL = (platform = "aws", env = "staging") => {
    return getBaseURL(platform, env) + "product_assets/usdz/";
}

export const getGLBBaseURL = (platform = "aws", env = "staging") => {
    return getBaseURL(platform, env) + "product_assets/glb/";
}


export const getUSDZAIBaseURL = (platform = "aws", env = "staging") => {
    return getBaseURL(platform, env) + "product_assets/ai_generated_usdz/";
}


export const getGLBAIBaseURL = (platform = "aws", env = "staging") => {
    return getBaseURL(platform, env) + "product_assets/ai_generated_glb/";
}


